<div class="absolute inset-0 flex min-w-0 flex-col overflow-auto">
    <!-- Main -->
    <div class="flex-1 flex flex-col">
        <!-- Header -->
        <div class="bg-default flex flex-col items-start px-6 py-8 sm:flex-row sm:items-center sm:justify-between md:px-8 flex-shrink-0">
            <!-- Title -->
            <div>
                <div class="text-4xl font-extrabold leading-none tracking-tight">All Courts</div>
                <div class="text-secondary ml-0.5 font-medium">
                    <span>View all courts across all venues</span>
                </div>
            </div>
            
            <!-- Search and Actions -->
            <div class="mt-4 sm:mt-0 flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                <!-- Search Bar -->
                <div class="relative w-full sm:w-64">
                    <div class="relative">
                        <mat-icon class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">search</mat-icon>
                        <input type="text" 
                               [(ngModel)]="searchQuery"
                               (ngModelChange)="onSearchInput()"
                               (focus)="showSearchDropdown = filteredCourts.length > 0 && searchQuery.trim() !== ''"
                               (blur)="onSearchBlur()"
                               placeholder="Search by name, venue, sport or company..."
                               class="w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white">
                        
                        <!-- Clear button -->
                        <button *ngIf="searchQuery" 
                                (click)="clearSearch()"
                                class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
                            <mat-icon class="text-sm">close</mat-icon>
                        </button>
                    </div>
                    
                    <!-- Search Dropdown -->
                    <div *ngIf="showSearchDropdown && filteredCourts.length > 0" 
                         class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-80 overflow-y-auto">
                        <div class="p-2">
                            <div class="text-xs font-semibold text-gray-500 px-3 py-2">Search Results ({{filteredCourts.length}})</div>
                            <div class="divide-y divide-gray-100">
                                <div *ngFor="let court of filteredCourts" 
                                     (click)="selectCourt(court)"
                                     class="px-3 py-3 hover:bg-blue-50 cursor-pointer transition-colors duration-150">
                                    <div class="flex items-center">
                                        <div class="w-8 h-8 rounded flex items-center justify-center mr-3" 
                                             [style.background-color]="court.sportColor + '20'">
                                            <img *ngIf="court.sportLogo" 
                                                 [src]="court.sportLogo" 
                                                 [alt]="court.sportName"
                                                 class="h-5 w-5"
                                                 onerror="this.style.display='none'; this.parentElement.innerHTML='<span class=\'text-xs font-bold\' [style.color]=\'' + court.sportColor + '\'>' + court.sports.charAt(0).toUpperCase() + '</span>'">
                                            <span *ngIf="!court.sportLogo" class="font-bold text-xs" [style.color]="court.sportColor">
                                                {{court.sports?.charAt(0)?.toUpperCase() || 'C'}}
                                            </span>
                                        </div>
                                        <div class="flex-1 min-w-0">
                                            <div class="font-medium text-gray-900 truncate">{{court.name}}</div>
                                            <div class="text-sm text-gray-500 truncate">
                                                {{court.sportName || 'No sport'}}
                                            </div>
                                            <div class="text-xs text-gray-400 mt-1">
                                                <span [ngClass]="{
                                                    'bg-green-100 text-green-800': court.status === 'active',
                                                    'bg-red-100 text-red-800': court.status === 'inactive'
                                                }" class="inline-flex items-center px-2 py-0.5 rounded">
                                                    {{court.status || 'Unknown'}}
                                                </span>
                                                <span class="mx-1">•</span>
                                                <span>{{court.venueName || 'No venue'}}</span>
                                                <span class="mx-1">•</span>
                                                <span>{{court.companyName || 'No company'}}</span>
                                            </div>
                                        </div>
                                        <mat-icon class="text-gray-400 ml-2">chevron_right</mat-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Selected Court Badge -->
                    <div *ngIf="selectedCourt" class="mt-2">
                        <div class="inline-flex items-center bg-blue-50 text-blue-700 px-3 py-1.5 rounded-full text-sm">
                            <div class="w-4 h-4 rounded mr-1 flex items-center justify-center" 
                                 [style.background-color]="selectedCourt.sportColor + '20'">
                                <img *ngIf="selectedCourt.sportLogo" 
                                     [src]="selectedCourt.sportLogo" 
                                     [alt]="selectedCourt.sportName"
                                     class="h-3 w-3"
                                     onerror="this.style.display='none'; this.parentElement.innerHTML='<span class=\'text-xs font-bold\' [style.color]=\'' + selectedCourt.sportColor + '\'>' + selectedCourt.sports.charAt(0).toUpperCase() + '</span>'">
                                <span *ngIf="!selectedCourt.sportLogo" class="text-xs font-bold" [style.color]="selectedCourt.sportColor">
                                    {{selectedCourt.sports?.charAt(0)?.toUpperCase() || 'C'}}
                                </span>
                            </div>
                            <span class="font-medium">{{selectedCourt.name}}</span>
                            <span class="mx-2">•</span>
                            <span class="text-xs">{{selectedCourt.sportName || 'Unknown'}}</span>
                            <button (click)="clearSearch()" class="ml-2 text-blue-500 hover:text-blue-700">
                                <mat-icon class="text-sm">close</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                
                <!-- Refresh Button -->
                <button mat-button 
                        (click)="refreshCourts()"
                        class="inline-flex items-center justify-center px-4 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 text-gray-700">
                    <mat-icon class="mr-2">refresh</mat-icon>
                    Refresh
                </button>
            </div>
        </div>

        <!-- Courts Table -->
        <div class="px-6 md:px-8 pb-8 flex-1 overflow-auto">
            <!-- Search Info -->
            <div *ngIf="isSearchActive" class="mb-4">
                <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center">
                            <mat-icon class="text-blue-600 mr-2">info</mat-icon>
                            <span class="text-blue-700">
                                Showing search results for "{{searchQuery}}"
                            </span>
                        </div>
                        <button mat-button 
                                (click)="clearSearch()"
                                class="text-blue-600 hover:text-blue-800">
                            Clear Search
                        </button>
                    </div>
                </div>
            </div>
            
            <!-- Courts Table -->
            <div *ngIf="recentCourtsDataSource.data.length > 0" class="mb-8 w-full">
                <div class="bg-white rounded-lg shadow overflow-hidden w-full">
                    <!-- Table Container -->
                    <div class="overflow-x-auto w-full">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Court
                                    </th>
                                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Sport & Venue
                                    </th>
                                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Type & Surface
                                    </th>
                                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Capacity
                                    </th>
                                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Price
                                    </th>
                                    <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                                <ng-container *ngFor="let court of recentCourtsDataSource.data; trackBy: trackByFn">
                                    <!-- Main Row -->
                                    <tr id="court-{{court._id}}" class="hover:bg-gray-50 cursor-pointer" (click)="toggleRow(court._id)">
                                        <!-- Court Column -->
                                        <td class="px-6 py-4 whitespace-nowrap">
                                            <div class="flex items-center">
                                                <div class="flex-shrink-0 h-10 w-10 rounded-lg flex items-center justify-center" 
                                                     [style.background-color]="court.sportColor + '20'">
                                                    <img *ngIf="court.sportLogo" 
                                                         [src]="court.sportLogo" 
                                                         [alt]="court.sportName"
                                                         class="h-6 w-6"
                                                         onerror="this.style.display='none'; this.parentElement.innerHTML='<span class=\'font-bold text-sm\' [style.color]=\'' + court.sportColor + '\'>' + court.sports.charAt(0).toUpperCase() + '</span>'">
                                                    <span *ngIf="!court.sportLogo" class="font-bold text-sm" [style.color]="court.sportColor">
                                                        {{court.sports?.charAt(0)?.toUpperCase() || 'C'}}
                                                    </span>
                                                </div>
                                                <div class="ml-4">
                                                    <div class="text-sm font-medium text-gray-900">{{court.name}}</div>
                                                    <div class="text-xs text-gray-500">
                                                        {{ court.status === 'active' ? 'Active' : 'Inactive' }}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        <!-- Sport & Venue Column -->
                                        <td class="px-6 py-4">
                                            <div class="text-sm text-gray-900">{{court.sportName || 'N/A'}}</div>
                                            <div class="text-xs text-gray-500 truncate max-w-xs">
                                                {{court.venueName || 'No venue'}}
                                                <span *ngIf="court.companyName" class="text-gray-400">
                                                     • {{court.companyName}}
                                                </span>
                                            </div>
                                        </td>

                                        <!-- Type & Surface Column -->
                                        <td class="px-6 py-4">
                                            <div class="space-y-1">
                                                <span class="inline-flex items-center rounded-full px-3 py-1 text-xs font-medium"
                                                      [ngClass]="{
                                                        'bg-green-100 text-green-800': court.courtType === 'outdoor',
                                                        'bg-purple-100 text-purple-800': court.courtType === 'indoor',
                                                        'bg-gray-100 text-gray-800': !court.courtType
                                                      }">
                                                    {{ court.courtType | titlecase }}
                                                </span>
                                                <div class="text-xs text-gray-600">
                                                    {{ court.surfaceType | titlecase }}
                                                </div>
                                            </div>
                                        </td>

                                        <!-- Capacity Column -->
                                        <td class="px-6 py-4">
                                            <div class="text-sm text-gray-900">
                                                {{court.minCapacity || '0'}} - {{court.maxCapacity || '0'}}
                                            </div>
                                            <div class="text-xs text-gray-500">
                                                AC: {{ court.airConditioned ? 'Yes' : 'No' }}
                                            </div>
                                        </td>

                                        <!-- Price Column -->
                                        <td class="px-6 py-4 whitespace-nowrap">
                                            <div class="text-sm font-semibold text-gray-900">
                                                {{court.currency}} {{court.pricePerHour || '0'}}
                                            </div>
                                            <div class="text-xs text-gray-500">per hour</div>
                                        </td>

                                        <!-- Actions Column -->
                                        <td class="px-6 py-4 whitespace-nowrap text-right">
                                            <div class="flex justify-end items-center space-x-1">
                                                <!-- Edit button -->
                                                <button mat-icon-button 
                                                        matTooltip="Edit Court"
                                                        class="text-blue-600 hover:bg-blue-50"
                                                        (click)="editCourt(court, $event)">
                                                    <mat-icon>edit</mat-icon>
                                                </button>
                                                
                                                <!-- Delete button -->
                                                <button *ngIf="canPerformDestructiveActions" mat-icon-button
                                                        matTooltip="Delete Court"
                                                        class="text-red-600 hover:bg-red-50"
                                                        (click)="deleteCourt(court._id, court.venueId, $event)">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                                
                                                <!-- Expand/Collapse button -->
                                                <button mat-icon-button 
                                                        matTooltip="View Details"
                                                        class="text-blue-600 hover:bg-blue-50"
                                                        (click)="toggleRow(court._id); $event.stopPropagation()">
                                                    <mat-icon *ngIf="expandedCourtId !== court._id">expand_more</mat-icon>
                                                    <mat-icon *ngIf="expandedCourtId === court._id">expand_less</mat-icon>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- Expanded Details Row -->
                                    <tr *ngIf="expandedCourtId === court._id" class="bg-blue-50">
                                        <td colspan="6" class="px-6 py-4">
                                            <div class="flex justify-end mb-2">
                                                <button mat-button 
                                                        (click)="editCourt(court, $event)"
                                                        class="text-blue-600 hover:text-blue-800">
                                                    <mat-icon class="mr-1">edit</mat-icon>
                                                    Edit Court
                                                </button>
                                            </div>
                                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                <!-- Court Details -->
                                                <div class="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
                                                    <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                                                        <mat-icon class="mr-2 text-blue-600">sports_tennis</mat-icon>
                                                        Court Details
                                                    </h3>
                                                    <div class="space-y-3">
                                                        <!-- Removed Court ID display -->
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400">title</mat-icon>
                                                            <span class="text-sm font-medium text-gray-600 mr-2">Name:</span>
                                                            <span class="text-sm font-semibold">{{court.name}}</span>
                                                        </div>
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400">sports</mat-icon>
                                                            <span class="text-sm font-medium text-gray-600 mr-2">Sport:</span>
                                                            <div class="flex items-center">
                                                                <div class="w-6 h-6 rounded mr-2 flex items-center justify-center" 
                                                                     [style.background-color]="court.sportColor + '20'">
                                                                    <img *ngIf="court.sportLogo" 
                                                                         [src]="court.sportLogo" 
                                                                         [alt]="court.sportName"
                                                                         class="h-4 w-4"
                                                                         onerror="this.style.display='none'; this.parentElement.innerHTML='<span class=\'text-xs font-bold\' [style.color]=\'' + court.sportColor + '\'>' + court.sports.charAt(0).toUpperCase() + '</span>'">
                                                                    <span *ngIf="!court.sportLogo" class="text-xs font-bold" [style.color]="court.sportColor">
                                                                        {{court.sports?.charAt(0)?.toUpperCase() || 'C'}}
                                                                    </span>
                                                                </div>
                                                                <span class="text-sm">{{court.sportName || 'N/A'}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400">verified</mat-icon>
                                                            <span class="text-sm font-medium text-gray-600 mr-2">Status:</span>
                                                            <span [ngClass]="{
                                                                    'text-green-600': court.status === 'active',
                                                                    'text-red-600': court.status === 'inactive',
                                                                    'text-gray-600': !court.status
                                                                  }" 
                                                                  class="text-sm font-medium">
                                                                {{ court.status === 'active' ? 'Active' : 
                                                                   court.status === 'inactive' ? 'Inactive' : 'Unknown' }}
                                                            </span>
                                                        </div>
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400">location_on</mat-icon>
                                                            <span class="text-sm font-medium text-gray-600 mr-2">Venue:</span>
                                                            <span class="text-sm">{{court.venueName || 'N/A'}}</span>
                                                        </div>
                                                        <!-- Court Type & Surface -->
                                                        <div class="grid grid-cols-2 gap-3 mt-3">
                                                            <div>
                                                                <div class="text-sm font-medium text-gray-600 mb-1">Court Type</div>
                                                                <span class="inline-flex items-center rounded-full px-3 py-1 text-xs font-medium"
                                                                      [ngClass]="{
                                                                        'bg-green-100 text-green-800': court.courtType === 'outdoor',
                                                                        'bg-purple-100 text-purple-800': court.courtType === 'indoor',
                                                                        'bg-gray-100 text-gray-800': !court.courtType
                                                                      }">
                                                                    {{ court.courtType | titlecase }}
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <div class="text-sm font-medium text-gray-600 mb-1">Surface</div>
                                                                <span class="text-sm">{{ court.surfaceType | titlecase }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Additional Information -->
                                                <div class="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
                                                    <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                                                        <mat-icon class="mr-2 text-green-600">info</mat-icon>
                                                        Additional Information
                                                    </h3>
                                                    <div class="space-y-3">
                                                        <!-- Capacity Details -->
                                                        <div>
                                                            <div class="flex items-center mb-1">
                                                                <mat-icon class="mr-2 text-gray-400" style="font-size: 16px;">groups</mat-icon>
                                                                <span class="text-sm font-medium text-gray-600">Capacity:</span>
                                                            </div>
                                                            <div class="grid grid-cols-2 gap-3">
                                                                <div>
                                                                    <div class="text-xs text-gray-500">Min Capacity</div>
                                                                    <div class="text-sm font-semibold text-gray-900">{{court.minCapacity || 'N/A'}}</div>
                                                                </div>
                                                                <div>
                                                                    <div class="text-xs text-gray-500">Max Capacity</div>
                                                                    <div class="text-sm font-semibold text-gray-900">{{court.maxCapacity || 'N/A'}}</div>
                                                                </div>
                                                            </div>
                                                            <div class="mt-2 text-sm text-gray-600">
                                                                Air Conditioned: {{ court.airConditioned ? 'Yes' : 'No' }}
                                                            </div>
                                                        </div>

                                                        <!-- Pricing Details -->
                                                        <div>
                                                            <div class="flex items-center mb-1">
                                                                <mat-icon class="mr-2 text-gray-400" style="font-size: 16px;">attach_money</mat-icon>
                                                                <span class="text-sm font-medium text-gray-600">Pricing:</span>
                                                            </div>
                                                            <div class="grid grid-cols-2 gap-3">
                                                                <div>
                                                                    <div class="text-xs text-gray-500">Price/Hour</div>
                                                                    <div class="text-sm font-semibold text-gray-900">{{court.currency}} {{court.pricePerHour || '0'}}</div>
                                                                </div>
                                                                <div>
                                                                    <div class="text-xs text-gray-500">Subtotal/Hour</div>
                                                                    <div class="text-sm font-semibold text-gray-900">{{court.currency}} {{court.subtotalPerHour || '0'}}</div>
                                                                </div>
                                                            </div>
                                                            <div class="grid grid-cols-2 gap-3 mt-2">
                                                                <div>
                                                                    <div class="text-xs text-gray-500">Tax/Hour</div>
                                                                    <div class="text-sm font-semibold text-gray-900">{{court.currency}} {{court.taxPerHour || '0'}}</div>
                                                                </div>
                                                                <div>
                                                                    <div class="text-xs text-gray-500">Total</div>
                                                                    <div class="text-sm font-semibold text-gray-900">{{court.currency}} {{court.total || '0'}}</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- Pictures -->
                                                        <div *ngIf="court.pictures && court.pictures.length > 0">
                                                            <div class="flex items-center mb-2">
                                                                <mat-icon class="mr-2 text-gray-400" style="font-size: 16px;">photo_library</mat-icon>
                                                                <span class="text-sm font-medium text-gray-600">Photos ({{court.pictures.length}})</span>
                                                            </div>
                                                            <div class="flex gap-2 overflow-x-auto pb-2">
                                                                <div *ngFor="let picture of court.pictures | slice:0:3" class="flex-shrink-0">
                                                                    <img [src]="picture" 
                                                                         alt="court photo" 
                                                                         class="h-16 w-16 rounded-lg object-cover border border-gray-200"
                                                                         onerror="this.style.display='none'">
                                                                </div>
                                                                <div *ngIf="court.pictures.length > 3" class="flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-lg bg-gray-100 border border-gray-200">
                                                                    <span class="text-sm text-gray-600">+{{ court.pictures.length - 3 }}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- Company Info -->
                                                        <div>
                                                            <div class="flex items-center mb-1">
                                                                <mat-icon class="mr-2 text-gray-400" style="font-size: 16px;">business</mat-icon>
                                                                <span class="text-sm font-medium text-gray-600">Company:</span>
                                                            </div>
                                                            <p class="text-sm text-gray-900">{{ court.companyName || 'N/A' }}</p>
                                                        </div>

                                                        <!-- Dates -->
                                                        <div class="pt-3 border-t border-gray-100">
                                                            <div class="grid grid-cols-2 gap-2 text-xs text-gray-500">
                                                                <div>
                                                                    <div class="font-medium">Created:</div>
                                                                    <div>{{ court.createdAt | date:'mediumDate' }}</div>
                                                                </div>
                                                                <div>
                                                                    <div class="font-medium">Updated:</div>
                                                                    <div>{{ court.updatedAt | date:'mediumDate' }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>

                    <!-- Table Footer with Pagination -->
                    <div class="bg-gray-50 px-6 py-3 border-t border-gray-200">
                        <div class="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                            <div class="text-sm text-gray-700">
                                Showing <span class="font-medium">{{recentCourtsDataSource.data.length}}</span> of 
                                <span class="font-medium">{{totalCourts}}</span> courts
                                <span *ngIf="isSearchActive" class="text-blue-600 ml-2">
                                    (Search Results)
                                </span>
                            </div>
                            
                            <mat-paginator [length]="totalCourts"
                                           [pageSize]="pageSize"
                                           [pageSizeOptions]="pageSizeOptions"
                                           [pageIndex]="currentPage"
                                           (page)="onPageChange($event)"
                                           aria-label="Select page"
                                           class="border-0">
                            </mat-paginator>
                            
                            <button mat-button 
                                    (click)="refreshCourts()"
                                    class="text-blue-600 hover:text-blue-800">
                                <mat-icon>refresh</mat-icon>
                                <span class="ml-1">Refresh</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="recentCourtsDataSource.data.length === 0" class="text-center py-12">
                <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 mb-4">
                    <mat-icon class="text-gray-400" style="width: 32px; height: 32px; font-size: 32px;">sports_tennis</mat-icon>
                </div>
                <h3 class="text-lg font-medium text-gray-900 mb-2">
                    {{ isSearchActive ? 'No matching courts found' : 'No courts found' }}
                </h3>
                <p class="text-gray-500 mb-4">
                    {{ isSearchActive ? 'Try a different search term' : 'There are no courts available at the moment.' }}
                </p>
                <button *ngIf="isSearchActive" 
                        mat-button 
                        (click)="clearSearch()"
                        class="text-blue-600 hover:text-blue-800">
                    Clear Search
                </button>
            </div>
        </div>
    </div>
</div>
